<template>
  <div class='spinner'></div>
</template>

<script>

export default {
    mounted() {
        // Center it vertically
        this.$el.style.marginTop = ((this.$el.parentNode.offsetHeight - this.$el.offsetHeight) / 2) + 'px';
    }
};

</script>

<style>

.spinner {
    border: 8px solid #f3f3f3; /* Light grey */
    border-top: 8px solid #d4451d; /* DL Orange */
    border-radius: 50%;
    width: 50px;
    height: 50px;
    margin-left: auto;
    margin-right: auto;
    align: center;
    vertical-align: middle;
    animation: spin 2s linear infinite;
}

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

</style>



// WEBPACK FOOTER //
// Spinner.vue?aa7a081a